import React, { useState } from 'react';
import serverRead from './toolkit/serverRead';
import ToolkitBatchPage from './toolkit/ToolkitBatchPage';

// Sync › project › Toolkit › Market Codes — ported from the desktop's OHIP › Market Codes. Finds the reservations
// arriving in a date range on the given market codes, then sets the chosen ones to a new market code (toolkit
// property.js update-market-code).

const today = () => new Date().toISOString().slice(0, 10);
const COLUMNS = [
    { key: 'confirmationNo', label: 'Confirmation' },
    { key: 'guestName', label: 'Guest' },
    { key: 'arrivalDate', label: 'Arrival' },
    { key: 'departureDate', label: 'Departure' },
    { key: 'marketCode', label: 'Market code' },
    { key: 'result', label: 'Result' },
];

function ToolkitMarketCodesPage() {
    const [from, setFrom] = useState(today());
    const [to, setTo] = useState(today());
    const [codes, setCodes] = useState('');
    const [newCode, setNewCode] = useState('');
    // On the server (a READ job): every reservation of the codes over the dates, paged, can outlast API Gateway.
    const fetchRows = async (ctx) => (await serverRead(ctx, { area: 'property', op: 'list-by-market-codes', screen: 'market-codes',
        title: 'Reservations by market code', args: {
            arrivalStartDate: from, arrivalEndDate: to, marketCodes: codes.split(',').map((c) => c.trim()).filter(Boolean),
        } })).items;
    const request = (row) => ({ area: 'property', op: 'update-market-code', args: { reservationId: row.reservationId, newMarketCode: newCode.trim() } });
    return (
        <ToolkitBatchPage title="Market Codes"
            subtitle="Find reservations by market code and arrival date, and move them to another market code."
            queryTitle="Reservations to change" fetchRows={fetchRows} canQuery={!!(from && to && codes.trim())}
            queryForm={(
                <>
                    <label><span>Arrival from</span><input type="date" value={from} onChange={(e) => setFrom(e.target.value)} /></label>
                    <label><span>Arrival to</span><input type="date" value={to} onChange={(e) => setTo(e.target.value)} /></label>
                    <label><span>Market codes (comma separated)</span><input type="text" value={codes} onChange={(e) => setCodes(e.target.value.toUpperCase())} style={{ width: 220 }} /></label>
                </>
            )}
            columns={COLUMNS} searchKeys={['confirmationNo', 'guestName', 'marketCode']} exportName="Market_Codes"
            request={request} server={{ screen: 'market-codes', title: 'Market Codes', keyOf: (row) => row.reservationId }}
            canRun={!!newCode.trim()}
            options={(
                <div className="tkb-row">
                    <label><span>New market code</span><input type="text" value={newCode} onChange={(e) => setNewCode(e.target.value.toUpperCase())} style={{ width: 140 }} /></label>
                </div>
            )} />
    );
}

export default ToolkitMarketCodesPage;
